
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdatePersonnelFileCategoryDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    slug: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    sortOrder: new FormControl<number | undefined>(undefined),
    active: new FormControl<boolean | undefined>(true),
})
;
}
      